export default __webpack_public_path__ + "static/media/avatar.85994bf0.svg";